import { Navigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '@/stores/auth-store';
import { setPostLoginRedirect } from '@/services/post-login-redirect';

export default function GroupEntryPage() {
  const { groupId } = useParams();
  const { isAuthenticated, _hasHydrated, user } = useAuthStore();

  if (!_hasHydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!groupId) {
    return <Navigate to="/app/groups" replace />;
  }

  const target = `/app/groups/${encodeURIComponent(groupId)}`;

  if (!isAuthenticated) {
    setPostLoginRedirect(target);
    return <Navigate to="/" replace />;
  }

  if (user && !user.onboardingCompleted) {
    setPostLoginRedirect(target);
    return <Navigate to="/onboarding" replace />;
  }

  return <Navigate to={target} replace />;
}
